const apiUrl = 'https://cashjarv2-api.azurewebsites.net';
export const environment = {
  production: true,
  rootAPI: apiUrl + '/',
  apiRoot: apiUrl + '/account/',
  adminAPIRoot: apiUrl + '/api/admin/',
  accountAPIRoot: apiUrl + '/account/api/account',
  inventoryAPIRoot: apiUrl + '/inventory/api/inventory',
  locationAPIRoot: apiUrl + '/account/api/account/location',
  terminalAPIRoot: apiUrl + '/account/api/account/terminal',
  auditTrailAPIRoot: apiUrl + '/account/api/account/audittrail',
  resetAccountAPIRoot: apiUrl + '/account/api/UserApiGee/',
  tenantAPIRoot: apiUrl + '/account/api/Tenant/',
  customerAPIRoot: apiUrl + '/merchantcustomer/api/customermanagement',
  invoiceAPIRoot: apiUrl + '/invoice/api/invoice',
  recurringPaymentAPIRoot: apiUrl + '/invoice/api/RecurringPayment',
  recurringInvoiceAPIRoot: apiUrl + '/invoice/api/RecurringInvoice',
  ordersAPIRoot: apiUrl + '/orders/api/orders',
  serviceworkorderAPIRoot: apiUrl + '/workorder/api/workorder',
  reportsAPIRoot: apiUrl + '/reports/api/reportsmanagement',
  estimatesAPIRoot: apiUrl + '/invoice/api/estimate',
  thirdPartyConfigAPIRoout: apiUrl + '/account/api/thirdparty',

  pushNotificationUrl: 'https://paymenthqvm.stagingpaymenthq.com:8090',
  paymentAPIRoot: apiUrl + '/payments',
  tipAPIRoot: apiUrl + '/tip/api/tip',
  networkAPIUrl: apiUrl + '/network/api/network',
  formbuilderAPIUrlRoot: apiUrl + '/account/api/FormIO',
  quickbooksAPIRoot: apiUrl + '/api/quickbooks',
  quickPaymentAPIRoot: apiUrl + '/quickpayment/api/QuickPaymentLink',
  mobileAPIRoot: apiUrl + '/mobile/api/mobileapi',
  csvTemplatesRoot: 'assets/import_templates',
  invoiceReminderAPIRoot: apiUrl + '/invoice/api/InvoiceReminder',
  commercialDataConfigurationAPIRoot: apiUrl + '/invoice/api/CommercialDataConfiguration',
  adminApiUrl: 'https://cjadmin-api.azurewebsites.net',
  apiKeysRoot: apiUrl + '/account/api/apikeys',

  appUrl: {
    webPort: 'https://{0}.servicepayapp.com/checkout',
    ecom: '{0}.servicepay.online',
    domain: 'paymentsmanagerplus.app',
    secondaryDomain: 'servicepayapp.com',
    appTrayEnv: 'prod',
  },
  googlePay: {
    environment: 'PRODUCTION',
  },
};
